<template>
  <div class="w-100">
    <div class="w-100" :class="{'mb-4' : index+1 < rooms.length}" v-for="(room,index) in rooms">
      <div class="d-flex align-items-start w-100">
        <div class="flex-shrink-0">
          <div class="mr-3 lh-1">
            <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6C4.64119 6 6 4.63825 6 3C6 1.35883 4.63825 0 2.99706 0C1.35883 0 0 1.35883 0 3C0 4.63825 1.36177 6 3 6Z" fill="#222222" fill-opacity="0.85"/>
            </svg>
          </div>
        </div>
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-start w-100">
            <div>
              <p class="mb-0 body-2-4">{{ room.name }}</p>
              <p class="mb-0 body-3">{{ room.room_type.name }}</p>
            </div>
            <div class="pl-2">
              <p class="mb-0 text-orange text-12 font-lato">{{ room.finalPriceFormat }}</p>
            </div>
          </div>
  
          <div v-if="!$isEmpty(room.transportProducts)" class="w-100 mt-2 border-form rounded">
            <div class="d-flex align-items-center bg-light border-b-form bg-light-page px-2-5 py-2 mb-2 rounded-top-4">
              <svg height="16" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.14628 35.2054L1.64404 40.3013C1.9227 41.1824 2.28843 41.8216 2.77608 42.288L5.04015 40.8196C4.43058 40.5777 4.03002 40.0941 3.80362 39.2995L2.63675 35.0154C2.54968 34.739 2.65417 34.549 2.95024 34.549H36.737C37.033 34.549 37.1201 34.7909 36.9112 35.0154L33.1494 39.2821C32.5572 39.9387 32.087 40.4915 31.0421 40.7851L33.1668 42.3399C34.0725 41.7179 34.769 40.8541 35.6747 39.8349L39.4365 35.5509C40.6731 34.1171 39.7674 32.1997 37.7645 32.1997H2.3581C0.459766 32.1997 -0.35878 33.4779 0.14628 35.2054ZM16.7262 33.6507H19.0773V1.17467C19.0773 0.535509 18.5374 0 17.893 0C17.2486 0 16.7262 0.535509 16.7262 1.17467V33.6507ZM18.0672 27.7083H25.2251C30.4674 27.7083 33.3758 25.048 33.3758 20.7466C33.3758 13.4223 25.7129 5.18234 18.5723 1.4856L17.3706 3.50673C23.2919 6.06335 31.0247 13.7332 31.0247 20.3839C31.0247 23.3897 28.8999 25.3589 25.2425 25.3589H18.0672V27.7083ZM19.5302 4.59502C25.3122 12.8177 23.4487 22.8197 17.9801 25.5663L18.4679 27.6047C25.9392 24.2016 27.7156 13.4568 21.5504 4.24952L19.5302 4.59502ZM4.36093 27.7083H17.6319V25.3589H6.62498C6.416 25.3589 6.32891 25.1517 6.50307 25.0308C12.4593 20.5739 17.9627 10.3129 18.8684 3.28215L16.7262 1.81382C16.8655 7.63533 11.3795 18.7083 3.38564 24.4608C1.6963 25.6872 2.63675 27.7083 4.36093 27.7083ZM18.4503 44.1536C23.1874 44.1536 23.9538 40.6469 26.7055 40.6469C29.5443 40.6469 29.9971 44.1536 35.4308 44.1536H37.1898C37.869 44.1536 38.4263 43.6008 38.4263 42.9271C38.4263 42.2535 37.869 41.7179 37.1898 41.7179H35.4308C33.5499 41.7179 32.505 40.9405 31.1813 40.0249C30.0493 39.2132 28.6386 38.2112 26.7055 38.2112C24.7201 38.2112 23.2919 39.2649 22.1425 40.1113C20.9582 41.0096 20.0004 41.7179 18.4503 41.7179C16.8829 41.7179 15.925 41.0096 14.7408 40.1113C13.5913 39.2649 12.1632 38.2112 10.1778 38.2112C8.24467 38.2112 6.83398 39.2132 5.70194 40.0249C4.37833 40.9405 3.33339 41.7179 1.45247 41.7179H1.36539C0.686172 41.7179 0.14628 42.2535 0.14628 42.9271C0.14628 43.6008 0.686172 44.1536 1.36539 44.1536H1.45247C6.88622 44.1536 7.33903 40.6469 10.1778 40.6469C12.9295 40.6469 13.6958 44.1536 18.4503 44.1536Z" fill="#222"/>
              </svg>
              <p class="mb-0 body-3-3-2 ml-2">Transport</p>
            </div>

            <div v-for="(routeType,routeTypeIndex) in room.transportProducts" class="px-2-5 d-block position-relative">
              <p class="mb-1-5 body-2-1">{{ routeType.title }} :</p>
              <div class="w-100 mb-2">
                <div v-for="product in routeType.products" class="d-flex align-items-center mb-1-5">
                  <div class="d-flex justify-content-between w-100">
                    <div class="d-flex w-100">
                      <span class="lh-1-3 mb-0 body-3-3-2 mr-1">{{ product.qty }}x</span>
                      <span class="lh-1-3 mb-0 body-3-3-2">{{ product.name }}</span>
                    </div>
                    <span :id="`${room.group_id}-${routeType.code}-${product.id}`" class="lh-1-3 mb-0 text-12 font-lato text-orange pl-2" :class="{'text-underline-dashed-offset-2 cursor-help' : product.cm_transport_route_type === 'ROUNDTRIP'}">{{ printTotalPrice(routeType.code, product) }}</span>
                    <b-tooltip v-if="product.cm_transport_route_type === 'ROUNDTRIP'" :target="`${room.group_id}-${routeType.code}-${product.id}`" placement="bottom">
                      This price includes both pickup and dropoff transfers
                    </b-tooltip>
                  </div>
                </div>
              </div>
              <template v-if="$isNotEmptyV2(routeType.other)">
                <div class="d-flex pl-1 mb-2">
                 <svg class="mr-2" style="margin-top: 5px !important;" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M3 6C4.64119 6 6 4.63825 6 3C6 1.35883 4.63825 0 2.99706 0C1.35883 0 0 1.35883 0 3C0 4.63825 1.36177 6 3 6Z" fill="#222222"/>
                 </svg>
 
                 <div class="d-flex align-items-top w-100 text-left">
                   <p class="mb-0 font-lato-regular text-12 flex-shrink-0 lh-1-2 text-light-dark">{{ `${routeType.title} time :` }}</p>
                   <p class="mb-0 font-lato-regular text-12 ml-2 lh-1-2">{{ formatDateTimeZone(routeType.other.service_date) }}</p>
                 </div>
                </div>
                <div class="d-flex pl-1 mb-2" v-if="$isNotEmptyV2(routeType.other.transport_code)">
                 <svg class="mr-2" style="margin-top: 5px !important;" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M3 6C4.64119 6 6 4.63825 6 3C6 1.35883 4.63825 0 2.99706 0C1.35883 0 0 1.35883 0 3C0 4.63825 1.36177 6 3 6Z" fill="#222222"/>
                 </svg>
 
                 <div class="d-flex align-items-top w-100 text-left">
                   <p class="mb-0 font-lato-regular text-12 flex-shrink-0 lh-1-2 text-light-dark">Flight Number :</p>
                   <p class="mb-0 font-lato-regular text-12 ml-2 lh-1-2">{{ routeType.other.transport_code }}</p>
                 </div>
                </div>
              </template>
              
              <div v-if="routeTypeIndex + 1 < room.transportProducts.length" class="my-2 border-b-form-dashed w-100"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

  export default {
    props: ['trx'],
    computed:{
      ...mapGetters(['getMerchant']),
      isMasked(){
        if(this.$isEmpty(this.trx)) return false;
        const { created_at = "*" } = this.trx;
        return created_at === "*";
      },
      transportProduct(){
        return this.trx.additional_service_details.filter(prd => prd.use_cm_transport);
      },
      rooms(){
        return this.trx.transaction_details.map(room => {
          const { dates, group_id = null, transport = {} } = room;  
          
          const finalPrice = dates.reduce((sum, val) => val.sub_total + sum, 0);
          room.finalPrice = finalPrice;
          room.finalPriceFormat = this.$formatCurrency(finalPrice, false, false, null, null, this.isMasked);
          
          room.transportProducts = this.filterTransportProduct(group_id, transport);
          
          return room;
        });

      }
    },
    methods:{
      filterTransportProduct(group_id, transport){
        if(this.$isEmpty(group_id)) return [];
        const products = this.transportProduct.filter(product => product.group_id === group_id);

        const getProductsByRoute = (key) => {
          return products.filter(product => {
            const { cm_transport_route_type: routeType } = product;
            return routeType === key || routeType === 'ROUNDTRIP';
          });
        };
        
        const routeTypeOptions = [
          { code: 'PICKUP', title: 'Pickup'},
          { code: 'DROPOFF', title: 'Dropoff'}
        ];

        let routeTypeList = [];

        routeTypeOptions.forEach(prd => {
          const { code, title } = prd;
          const products = getProductsByRoute(code);
          if(products.length > 0){
            const lowerCaseCode = code.toLowerCase();
            const other = this.$isEmpty(transport[lowerCaseCode]) ? {} : transport[lowerCaseCode]

            routeTypeList.push({code, title, products, other})
          }
        });
        
        return routeTypeList;
      },
      printTotalPrice(routeTypeCode, product){
        const { qty, cm_transport_route_type: routeType, price } = product;

        const isRoundTrip = routeType === 'ROUNDTRIP';
        const currentRouteTypeDropoff = routeTypeCode === 'DROPOFF';
        if(isRoundTrip && currentRouteTypeDropoff) return "Included";

        const totalPrice = Number(price) * qty;

        return this.$formatCurrency(totalPrice);
      },
      formatDateTimeZone(serviceDateTime){
        const m = moment(serviceDateTime, 'YYYY-MM-DD HH:mm').tz(this.getMerchant.timezone, true);
        const totalMin = m.utcOffset();
        const sign = totalMin < 0 ? "-" : "+";
        const absMin = Math.abs(totalMin);
        const hh = Math.floor(absMin / 60);
        const mm = absMin % 60;
        const label = mm ? `GMT${sign}${hh}:${String(mm).padStart(2, "0")}` : `GMT${sign}${hh}`;

        const pattern = 'ddd, DD MMM YYYY, HH:mm';
        return `${m.locale('en').format(pattern)} (${label})`;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/BookingResultPerRoom.vue